import { request } from "./index";

const askQuestion = async <T>({ content, videoText }: { content: string; videoText?: string }) => {
  return request<T>({ method: "POST", url: "/video/insertAIQuestion", data: { content, videoText } });
};

const getLatestAnswer = async <T>() => {
  return request<T>({ method: "POST", url: "/video/transcriptionToChatGpt" });
};

const getRemainCount = async <T>() => {
  return request<T>({ method: "POST", url: "/video/getChatGptRemain" });
};

const getHistoryMessages = async <T>() => {
  return request<T>({ method: "POST", url: "/video/queryChatGptList" });
};

export default { askQuestion, getLatestAnswer, getRemainCount, getHistoryMessages };
